export const AGENCY_SCOPE_ALL = "all";
export const AGENCY_SCOPE_SERSEO = "serseo";
export const AGENCY_SCOPE_EXTERNAL = "external";
export const AGENCY_SCOPE_MANUAL = "manual";

export const CLIENT_MODE_NONE = "none";
export const CLIENT_MODE_ALL = "all";
export const CLIENT_MODE_SELECTED = "selected";

/** IDs de las agencias que cubre el público elegido; `null` = todas. */
export const resolveAudienceAgencyIds = (formState, agencyOptions) => {
  const scope = formState.agencyScope;
  if (scope === AGENCY_SCOPE_ALL) return null;
  if (scope === AGENCY_SCOPE_SERSEO || scope === AGENCY_SCOPE_EXTERNAL) {
    return new Set(
      agencyOptions
        .filter((agency) => agency.agencyType === scope)
        .map((agency) => String(agency.value))
    );
  }
  return new Set(
    (formState.targetAgencies || []).map((agency) => String(agency.value))
  );
};

/** Agencias que cubre el público elegido. */
export const resolveAudienceAgencies = (formState, agencyOptions) => {
  const agencyIds = resolveAudienceAgencyIds(formState, agencyOptions);
  return agencyIds === null
    ? agencyOptions
    : agencyOptions.filter((agency) => agencyIds.has(String(agency.value)));
};

export const filterClientsByAgencyIds = (clients, agencyIds) =>
  agencyIds === null
    ? clients || []
    : (clients || []).filter((client) =>
      agencyIds.has(String(client.agencyId))
    );

export const buildAgencyAudiencePayload = (formState) => {
  if (formState.agencyScope === AGENCY_SCOPE_ALL) return { all: true };
  if (
    formState.agencyScope === AGENCY_SCOPE_SERSEO ||
    formState.agencyScope === AGENCY_SCOPE_EXTERNAL
  ) {
    return { target_agency_type: formState.agencyScope };
  }
  return {
    target_agency_type: null,
    target_agencies: (formState.targetAgencies || []).map(
      (agency) => agency.value
    ),
  };
};
